import React from "react";
import {useSelector} from "react-redux";
import {selectAppLoading} from "../../../store/slices/app/selectors";
import {LoaderBackdrop} from "./styles";
import vessel from '../../../assets/images/reservation/vessel.svg';

const Loader = () => {
    const loading = useSelector(selectAppLoading);

    if(!loading) {
        return null;
    }

    return <LoaderBackdrop>
        <div id="outerContainer">
            <div id="container">
                <div className="item">
                    <img src={vessel} />
                </div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
            </div>
        </div>
    </LoaderBackdrop>
}

export default Loader;
